import TextField from "@mui/material/TextField";
import React from "react";
import InputAdornment from "@mui/material/InputAdornment";

type TextFieldProps = {
  label?: string;
  variant: "outlined" | "standard" | "filled";
  required?: true | false;
  placeholder?: string;
  multiline?: true | false;
  fullWidth?: true | false;
  id?: string;
  name?: string;
  rows?: number;
  type?: string;
  value?: any;
  className?: string;
  disabled?: false | true;
  onChange: (value: any) => void;
  endAdornment?: React.ReactNode;
};

export default function TextComponent(props: TextFieldProps) {
  return (
    <TextField
      label={props.label}
      variant={props.variant}
      required={props.required}
      placeholder={props.placeholder}
      multiline={props.multiline}
      fullWidth={props.fullWidth}
      id={props.id}
      name={props.name}
      rows={props.rows}
      size={"small"}
      type={props.type}
      value={props.value}
      disabled={props.disabled}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(event.target);
      }}
      className={props.className}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">{props.endAdornment}</InputAdornment>
          ),
        },
      }}
    />
  );
}
